import React from 'react';

const QuoteDetailMetaDataLoaderRow = () => (
    <>
        <td className="md:w-[14.28%] p-3 space-y-1">
            <h6 className="table-metadata-heading">Service Type</h6>
            <div className="custom-loading rounded-md border border-borderPrimary px-[6px] py-px w-fit text-xs">Lorem</div>
        </td>
        <td className="md:w-[14.28%] p-3 space-y-1">
            <h6 className="table-metadata-heading">Pickup Date</h6>
            <div className="custom-loading rounded-md w-fit text-sm leading-[20px]">Lorem Ipsum</div>
        </td>
        <td className="md:w-[14.28%] p-3 space-y-1">
            <h6 className="table-metadata-heading">From</h6>
            <div className="custom-loading rounded-md w-fit text-sm leading-5 lg:leading-[22px]">Lorem Ipsum</div>
        </td>
        <td className="md:w-[14.28%] p-3 space-y-1">
            <h6 className="table-metadata-heading">To</h6>
            <div className="custom-loading rounded-md w-fit text-sm leading-[20px]">Lorem Ipsum</div>
        </td>
        <td className="md:w-[14.28%] p-3 space-y-1">
            <h6 className="table-metadata-heading">Total Weight</h6>
            <div className="custom-loading rounded-md w-fit text-sm leading-[20px]">Lorem Ipsum</div>
        </td>
        <td className="md:w-[14.28%] p-3 space-y-1">
            <h6 className="table-metadata-heading">Linear Footage</h6>
            <div className="custom-loading rounded-md w-fit text-sm leading-[20px]">Lorem Ipsum</div>
        </td>
        <td className="md:w-[14.28%] p-3 space-y-1">
            <h6 className="table-metadata-heading">Equipment Type</h6>
            <div className="custom-loading rounded-md border border-borderPrimary px-[6px] py-px w-fit text-xs">Lorem</div>
        </td>
    </>
);

export default QuoteDetailMetaDataLoaderRow;
